// src/config/siteNavFallback.js

/**
 * Fallback delle voci di menu (header) e del footer del sito www.stirup.it.
 *
 * Usato SOLO quando l'endpoint /api/ui/site-nav non e' ancora stato popolato
 * (primo avvio / tabella vuota) o non e' raggiungibile e non c'e' cache locale.
 * L'app rende SEMPRE da qui, dalla cache locale, o dal dato del server --
 * MAI fetchando il sito direttamente.
 *
 * Copia allineata a mano al contenuto di:
 *   https://www.stirup.it/app/header.html
 *   https://www.stirup.it/app/footer.html
 * Aggiornare quando il menu/footer del sito cambia in modo sostanziale.
 * Ultimo allineamento: 2026-09-29
 */

export const SITE_NAV_FALLBACK = {
  header: [
    {
      label: "Servizi",
      url: "https://www.stirup.it/servizi-stirup.html",
    },
    {
      label: "Come funziona",
      url: "https://www.stirup.it/come-funziona-stirup.html",
    },
    {
      label: "Calendario antipanico",
      url: "https://www.stirup.it/calendario-anti-panico.html",
    },
    {
      label: "Promo aziendali",
      url: "https://www.stirup.it/promo-aziendali-stirup.html",
    },
  ],
  footer: {
    columns: [
      {
        title: "Il servizio",
        items: [
          {
            label: "Servizi",
            url: "https://www.stirup.it/servizi-stirup.html",
          },
          {
            label: "Come funziona",
            url: "https://www.stirup.it/come-funziona-stirup.html",
          },
          {
            label: "FAQ",
            url: "https://www.stirup.it/stiro-a-domicilio-stirup-faq.html",
          },
        ],
      },
      {
        title: "Info legali",
        items: [
          {
            label: "Condizioni generali",
            url: "https://www.stirup.it/condizioni-generali-stirup.html",
          },
          {
            label: "Privacy",
            url: "https://www.stirup.it/privacy.html",
          },
        ],
      },
      {
        title: "Chi siamo",
        items: [
          {
            label: "About us",
            url: "https://www.stirup.it/stiro_a_domicilio_about-us.html",
          },
          {
            label: "Our team",
            url: "https://www.stirup.it/stiro_a_domicilio_our-team.html",
          },
        ],
      },
      {
        title: "Amenities",
        items: [
          {
            label: "Citta' attive",
            url: "https://www.stirup.it/stiro_a_domicilio_about-us.html",
          },
          {
            label: "Vuoi iscriverti come fornitore?",
            url: "https://www.stirup.it/fornitori.html",
          },
        ],
      },
    ],
    social: [
      {
        platform: "facebook",
        url: "https://www.facebook.com/profile.php?id=61580009716134",
      },
      {
        platform: "instagram",
        url: "https://www.instagram.com/stirup7/",
      },
    ],
    // Badge store: immagine bundled (client/public/img/badges), niente rete
    stores: [
      {
        store: "apple",
        url: "https://apps.apple.com/it/app/stirup/id6761360133",
        img: "/img/badges/app-store-it.svg",
        alt: "Scarica su App Store",
        label: "Scarica StirUp su App Store",
      },
    ],
    copy: "© StirUp – tutti i diritti riservati.",
  },
};

export default SITE_NAV_FALLBACK;
